import React from "react";
import PropTypes from "prop-types";
import { sizes, srcset } from "../../../helpers/image";
import Teaser from "../Teaser";
import { Grid, Item } from "../ThreeColumn";
import { parseDate, formatDate } from "../../../helpers/dates";
import Placeholder from "../Teaser/Placeholder";

function formatYear(dateString) {
  if (typeof dateString === "string") {
    const date = parseDate(dateString, "yyyy-MM-dd");
    return formatDate(date, "yyyy");
  }
}

const List = ({ publications, isLoading }) => {
  const width = 570;
  const imageSizes = sizes(width, 3);

  return (
    <Grid gap="wide">
      {publications.map((publication) => {
        const imageSrcset = srcset(
          width,
          publication.image_retina,
          publication.image_default
        );

        return (
          <Item key={publication.id}>
            <Teaser
              imageSrc={publication.image_default}
              imageSrcset={imageSrcset}
              imageSizes={imageSizes}
              imageAlt={publication.image_alt}
              imageWidth={width}
              heading={publication.name}
              text={formatYear(publication.date)}
              url={publication.url}
            />
          </Item>
        );
      })}
      {isLoading && <Placeholder paddingTop="100%" />}
    </Grid>
  );
};

List.propTypes = {
  publications: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default List;
